require('jquery-validation');

class FormFields {
  static confirmEmail(emailStr) {
    return document.getElementById('email').value === emailStr;
  }

  static duplicateField(firstId, copyId) {
    $(`#${firstId}`).keyup(() => {
      const curVal = $(this).val(); // grab what's in the field
      // do stuff with curVal so that it's what you want
      $(`#${copyId}`).val(curVal);
    });
  }

  static fieldsHaveContent(fieldSetArray) {
    for (let i = 0; i < fieldSetArray.length; i += 1) {
      if ($(`[name='${fieldSetArray[i]}']`).val().length < 1) {
        FormFields.errorAlert(`Please fill in ${$(`label[for=${fieldSetArray[i]}]`).text()}`);
        $(`[name='${fieldSetArray[i]}']`).focus();
        return false;
      }
    }
    return true;
  }

  static errorAlert(msg) {
    const errorModal = $('div.alert-danger');
    if (errorModal.length === 0) {
      // Create the modal
      $('#srb_content_wrapper').prepend(`<div class="alert alert-danger alert-visual-static efile"><strong>Error!</strong> ${msg}</div>`);
    } else {
      // Alter existing modal
      errorModal.fadeOut(500);
      errorModal.html(`<strong>Error!</strong> ${msg}`);
      errorModal.fadeIn(500);
    }
    return false;
  }

  static checkRequiredFields(fields) {
    const missingRequirements = fields.filter((field) => {
      const value = document.getElementById(field).value;
      return value === null || value === undefined || value === '';
    });
    const isMissingRequirements = missingRequirements.length > 0;

    if (isMissingRequirements) {
      const fieldName = document.querySelector(`#group_${missingRequirements[0]} label`).innerHTML.replace(':', '');
      FormFields.errorAlert(`Missing required field: ${fieldName}`);
      document.getElementById(missingRequirements[0]).focus();
    }
    return !isMissingRequirements;
  }

  static validateFields(regexValidations) {
    const regexFields = Object.keys(regexValidations);
    const invalidFields = regexFields.filter((field) => {
      const regex = regexValidations[field].regex;
      const value = document.getElementById(field).value;
      return value !== null && value !== undefined && value !== '' && regex.test(value) === false;
    });
    const isInvalid = invalidFields.length > 0;

    if (isInvalid) {
      const fieldName = document.querySelector(`#group_${invalidFields[0]} label`).innerHTML.replace(':', '');
      const message = regexValidations[invalidFields[0]].message;
      FormFields.errorAlert(`Incorrect format for ${fieldName}: ${message}`);
      document.getElementById(invalidFields[0]).focus();
    }

    return !isInvalid;
  }
}

module.exports = FormFields;



// WEBPACK FOOTER //
// ./src-assets/js/form-fields.js